export const formatPrice = (price: number | null): string => {
  if (price === null || isNaN(price)) return '$ 0.00';
  return `$ ${price.toFixed(2)}`;
}; 
/** A keywords order is a plain Keyword order or a Keyword PRO one. */
export const isKeywordsProOrder = (subtype?: string | null): boolean =>
  subtype === 'KEYWORDS_PRO';

/** The type filter of the campaign lists: the types the Type column shows. */
export const ORDER_TYPE_OPTIONS = [
  { value: 'all', label: 'All types' },
  { value: 'keywords', label: 'Keywords' },
  { value: 'keywords_pro', label: 'Keyword PRO' },
  { value: 'direct', label: 'Direct' },
  { value: 'ratings', label: 'Ratings' },
  { value: 'reviews', label: 'Reviews' },
];

/** Whether an order is of the type picked in ORDER_TYPE_OPTIONS. */
export const matchesOrderType = (
  selected: string,
  orderType?: string | null,
  subtype?: string | null,
): boolean =>
  selected === 'all' ||
  (isKeywordsProOrder(subtype)
    ? 'keywords_pro'
    : (orderType || '').toLowerCase()) === selected;

/** Order type caption: "Keywords", "Direct", … or "Keyword PRO". */
export const formatOrderType = (
  orderType?: string | null,
  subtype?: string | null,
): string => {
  if (isKeywordsProOrder(subtype)) return 'Keyword PRO';
  return orderType ? orderType.charAt(0).toUpperCase() + orderType.slice(1) : '';
};

/** The contractor is paid in yuan; Revenue takes a yuan as this many dollars. */
export const CNY_TO_USD = 0.15;

/**
 * Money to the thousandth: "$60.00", "$0.065", "-$1.235" (a third decimal
 * only when it is not a zero) or "—".
 */
export const formatThousandths = (
  value?: number | null,
  symbol = '$',
): string => {
  if (value == null || !Number.isFinite(Number(value))) return '—';
  const amount = Number(value);
  const text = Math.abs(amount).toFixed(3);
  const sign = amount < 0 && Number(text) !== 0 ? '-' : '';
  return `${sign}${symbol}${text.endsWith('0') ? text.slice(0, -1) : text}`;
};

/**
 * "$0.28", "$0.065" or "—". The rate is the user's price per install for
 * their level and store, as the order was sold at; the backend stores it per
 * row, it is not Sell / installs.
 */
export const formatInstallRate = formatThousandths;

interface InstallOrder {
  totalInstalls?: number | string | null;
}

/**
 * Installs of every order in a list. The price per install gets no total:
 * it is the price of one install, not an amount to add up.
 */
export const getTotalInstalls = (orders: InstallOrder[]) =>
  orders.reduce((sum, order) => sum + (Number(order.totalInstalls) || 0), 0);
